import { render, staticRenderFns } from "./ConfigDrawer.vue?vue&type=template&id=88223b88&scoped=true"
import script from "./ConfigDrawer.vue?vue&type=script&lang=js"
export * from "./ConfigDrawer.vue?vue&type=script&lang=js"
import style0 from "./ConfigDrawer.vue?vue&type=style&index=0&id=88223b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88223b88",
  null
  
)

export default component.exports